import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property, query } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../BlocksElement';
import styles from './pagination-item.styles';

/**
 * @slot default - The component content
 * @csspart base - The component's base wrapper.
 * @csspart link - The component's link.
 * @csspart part-default - The component's default slot.
 */
export class BlocksPaginationItem extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * The text of the item link
   */
  @property({ type: String })
  text: string | undefined;

  /**
   * Divide adds a divider in between items to show that it's not orderd (e.g. item with 5 and then next item is 22)
   */
  @property({ type: Boolean })
  divide: boolean | undefined;

  /**
   * Disabled item
   */
  @property({ type: Boolean })
  disabled: boolean | undefined;

  /**
   * Active class for current item
   */
  @property({ type: Boolean })
  isActive: boolean | undefined;

  /**
   * Aria label for the link for accessibility
   */
  @property({ type: String })
  arialabel: string | undefined;

  @query('.cat-c-pagination__link')
  private paginationLink!: HTMLAnchorElement;

  override focus(options?: FocusOptions) {
    this.paginationLink.focus(options);
  }

  render(): TemplateResult<1> {
    const componentClassNames = this.componentClassNames('cat-c-pagination__item', {
      'cat-c-pagination__item--divide': this.divide === true,
      'cat-c-pagination__item--disabled': this.disabled === true,
      'cat-is-active': this.isActive === true
    });

    return html`
      <li part="base" role="listitem" class="${componentClassNames}">
        <a
          part="link"
          class="cat-c-pagination__link"
          aria-label=${ifDefined(this.arialabel)}
          aria-disabled=${this.disabled === true ? 'true' : 'false'}
          tabindex=${this.disabled === true ? '-1' : '0'}
        >
          <slot part="part-default"></slot>
        </a>
      </li>
    `;
  }
}

if (customElements.get('cat-pagination-item') === undefined) {
  customElements.define('cat-pagination-item', BlocksPaginationItem);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-pagination-item': BlocksPaginationItem;
  }
}
